export var captureError = function (message) {
    var _a, _b;
    (_b = (_a = window.Sentry) === null || _a === void 0 ? void 0 : _a.captureMessage) === null || _b === void 0 ? void 0 : _b.call(_a, message);
};
export var captureGqlError = function (error) {
    var _a, _b;
    (_b = (_a = window.Sentry) === null || _a === void 0 ? void 0 : _a.captureException) === null || _b === void 0 ? void 0 : _b.call(_a, error);
};
